import { useCampaignContext } from 'modules/campaigns/editor/context';
import { StyledButtons } from 'modules/campaigns/editor/styles';
import { CampaignType } from 'modules/domains/campaign';
import { NoOpComponent } from 'utils/reactHelpers';
import { EditViewActionsOnReviewPage } from '../EditViewActions';
import { BlastCampaignSummaryViewActions } from './BlastCampaignSummaryViewActions';
import { TriggeredCampaignSummaryViewActions } from './TriggeredCampaignSummaryViewActions';
import { EligibilityCampaignSummaryViewActions } from './EligibilityCampaignSummaryViewActions';

const CAMPAIGN_TYPE_SUMMARY_VIEW_ACTIONS_MAPPER = {
  [CampaignType.Blast]: BlastCampaignSummaryViewActions,
  [CampaignType.ApiTriggered]: TriggeredCampaignSummaryViewActions,
  [CampaignType.WorkflowTriggered]: TriggeredCampaignSummaryViewActions,
  [CampaignType.Eligibility]: EligibilityCampaignSummaryViewActions,

  /** NOTE: These doesn't represent a campaign in our database, they're just used for filtering campaigns */
  [CampaignType.WithAI]: NoOpComponent,
  [CampaignType.WithExperiment]: NoOpComponent,
};

export const SummaryViewActions = () => {
  const {
    campaign: { campaignTypeDefinition },
  } = useCampaignContext();

  const Actions = CAMPAIGN_TYPE_SUMMARY_VIEW_ACTIONS_MAPPER[campaignTypeDefinition];

  return (
    <StyledButtons>
      <EditViewActionsOnReviewPage />
      <Actions />
    </StyledButtons>
  );
};
